module.exports = __webpack_public_path__ + "img/giftsshop.3d2d8112.svg";